import { Link, Navigate, useParams } from "react-router-dom";
import { appUrl } from "../config";
import { useHubVisitor, withVisitor } from "../hubContext";

const COPY = {
  buyers: {
    title: "Benefits for buyers",
    lead: "A guided discovery, not a listing feed. You decide what home feels like — at your pace.",
    points: [
      "Location, home type, lot, exterior, interior, lifestyle, and accessibility stay on your carpet.",
      "Notes travel with you. Your agent sees a file they can use.",
      "Client vendors here are educational companions — movers, inspectors, closing primers — not ads.",
      "Support and the User Guide explain the why. REChecklist holds the checklist.",
    ],
    next: "/support/buyer",
    desk: "/",
  },
  sellers: {
    title: "Benefits for sellers",
    lead: "A listing brief built from features, condition, and photos — never mixed with buyer state.",
    points: [
      "Portfolio and readiness live on the seller journey only.",
      "Photos stay with the brief, not a public gallery.",
      "Staging, cleaning, and renovation notes live in the vendor hub as placeholders until your office fills them.",
      "You leave with something your agent can actually use.",
    ],
    next: "/support/seller",
    desk: "/seller/home",
  },
  agents: {
    title: "Benefits for agents",
    lead: "A framed woodland desk: clients, files, calendar, and two messaging rooms that never mix.",
    points: [
      "File Packet holds the work. Client Messaging is for buyers and sellers. Office Messaging is for colleagues.",
      "Hub events from San Diego County appear on your REChecklist calendar when they are relevant.",
      "Guided Tour and the A–Z User Guide live on this site so the desk can stay a workspace.",
      "Suggestions from the sidebar reach Admin without a second inbox product.",
    ],
    next: "/support/agent",
    desk: "/agent/login",
  },
  brokers: {
    title: "Benefits for brokers",
    lead: "Supervise the office, keep a retention habit, and archive conversations without a sales-floor tone.",
    points: [
      "My Business versus All Agents. Retention is a log, not a scramble.",
      "Broker opens and leadership events sit on the hub calendar.",
      "Pricing and PayPal checkout live here. The desk stays a workflow.",
      "Admin Controls on REChecklist edit what this site shows.",
    ],
    next: "/support/broker",
    desk: "/broker/login",
  },
};

export default function Benefits() {
  const { role } = useParams();
  const visitor = useHubVisitor();
  const copy = COPY[role];
  if (!copy) return <Navigate to={withVisitor("/", visitor)} replace />;

  return (
    <article>
      <h1>{copy.title}</h1>
      <p className="lead">{copy.lead}</p>
      <div className="card-grid">
        {copy.points.map((point) => (
          <section key={point} className="card">
            <p>{point}</p>
          </section>
        ))}
      </div>
      <p className="btn-row" style={{ justifyContent: "flex-start" }}>
        <Link className="btn" to={withVisitor(copy.next, visitor)}>
          Open support
        </Link>
        <a className="btn btn-ghost" href={role === "buyers" || role === "sellers" ? appUrl(copy.desk) : appUrl(copy.desk)}>
          Open REChecklist
        </a>
      </p>
    </article>
  );
}
